export const ZoomLevelValues = Object.freeze({
    minZoom: 10
});
